import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector, shallowEqual } from 'dva'
import { message } from 'antd'
import { loginRedirectUrl } from 'utils'
import Form from 'rc-field-form'
import { FormItem, Button } from 'components'
import { PhoneInput, CodeInput } from 'app/login/components'
import { phoneValidator, getApplication } from 'utils'
import styles from './index.module.less'

const selector = ({ login, session, loading }) => ({
  userInfo: session.userInfo,
  limit: login.limit,
  loading: ['login/onGeetest', 'login/login'].some(
    item => loading.effects[item]
  ),
})
export default function Index() {
  const dispatch = useDispatch()
  const { userInfo, limit, loading } = useSelector(selector, shallowEqual)
  const history = useHistory()

  const [mobile, setMobile] = useState({})
  const [clickTime, setClickTime] = useState(true)
  const [form] = Form.useForm()

  const onValuesChange = () => {
    const values = form.getFieldsValue()
    setMobile(values?.mobile)
  }

  const __dev__ = process.env.NODE_ENV === 'development'
  const initialValues = {
    mobile: __dev__
      ? {
          mobile: '18311092677',
          areaCode: '+86',
        }
      : '',
    validCode: __dev__ ? '123456' : '',
  }

  const onFinish = values => {
    if (!clickTime) return message.error('操作频繁，请稍后再试')
    setClickTime(false)
    setTimeout(() => setClickTime(true), 2000)

    dispatch({
      type: 'login/login',
      payload: {
        workId: userInfo?.workId,
        areaCode: values?.mobile?.areaCode,
        mobile: values?.mobile?.mobile,
        validCode: values?.validCode,
        returnUrl: loginRedirectUrl(),
        applicationCode: getApplication(),
        limit,
        loginType: 'phone',
        history,
      },
    })
  }

  useEffect(() => {
    if (__dev__) {
      setMobile({
        mobile: '18311092677',
        areaCode: '+86',
      })
    }
  }, [__dev__])

  return (
    <Form
      form={form}
      onFinish={onFinish}
      className={styles.idLogin}
      onValuesChange={onValuesChange}
      initialValues={initialValues}>
      <div className={styles.formItem}>
        <FormItem
          name="mobile"
          rules={[
            { required: true, message: '请输入手机号码' },
            { validator: phoneValidator },
          ]}>
          <PhoneInput maxLength={11} />
        </FormItem>
      </div>
      <div className={styles.formItem}>
        <FormItem
          name="validCode"
          rules={[
            { required: true, message: '请输入验证码' },
            { pattern: /^\d{6}$/, message: '请输入正确的验证码' },
          ]}>
          <CodeInput
            mobile={{ ...mobile, smsType: 'VALIDATION_CODE' }}
            maxLength={6}
          />
        </FormItem>
      </div>
      <Button type="primary" htmlType="submit" loading={loading}>
        登 录
      </Button>
    </Form>
  )
}
